module.exports = __webpack_public_path__ + "images/deals_import_example.png";